$(window).on('load', function() {
  if($('.orichi-quantity-textError').length){
      $('.js-popup').addClass('is-hidden');
  }
});
$(function () {
  $('.js-popup').magnificPopup({
      type: 'inline',
      midClick: true,
      preloader: false,
      removalDelay: 300,
      closeOnBgClick: false,
      closeBtnInside: false,
      showCloseBtn: false,
	callbacks: {
      
		open: function() {
			currentScroll = $(window).scrollTop();
          
			$('body').css({
			  top: -1 * currentScroll,
              
			});
          $('body').addClass("is-fixed");
          
		},
		close: function() {
          $('body').removeClass("is-fixed");
			window.scrollTo( 0 , currentScroll );
		}
      
	}	
  });
  //閉じるリンクの設定
  $(document).on('click', '.popup-modal-dismiss', function (e) { 
    e.preventDefault();
    $.magnificPopup.close();
    
  });
  $(document).on('click', '.shopify-product-form .buy-buttons button', function (e) { 
    $.magnificPopup.close();
  });

  $('.shopify-product-form .buy-buttons button').removeClass("is-active");
  $('.attention input[type="radio"]').prop('checked',false); 
  
  $('.page-top .product-info__block-item:is([data-block-type="buy-buttons"])').appendTo('#popup_btn');  
  
  $(document).on('change', '.attention input', function (e) { 
  	$('.shopify-product-form .buy-buttons button').removeClass("is-active");
  	if($('.attention input[name=q1]:checked').val() === 'yes'){
  		if($('.attention input[name=q2]:checked').val() === 'yes'){
  			if($('.attention input[name=q3]:checked').val() === 'yes'){
  				if($('.attention input[name=q4]:checked').val() === 'yes'){
  					$('.shopify-product-form .buy-buttons button').addClass("is-active");
  				}
  			}
  		}
  	}
  });

	//カートに入れるの表示切替
	function carbtnShow() {
		setTimeout(function(){
            $('.popup_area').hide();
			var display = "none";
			if($('#BIS_trigger').length){
				display = $('#BIS_trigger').css("display");
			}
			
			if(display=="none"||display==""){
				$('.popup_area').show();
			}
			else{
				$('.popup_area').hide();
			}
		},500);
	}
  	
  	carbtnShow();
  	
	$('.variant-picker__option-values').change(function() {
		carbtnShow();
	});
	
});